import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import { normalizeSshKey } from "./normalizeSshKey";

import type { ApiSshKeyListResponse, SshKeyListResponse } from "./types";

export const getSshKeysRequest = (userId: string) =>
  fetchAllPages(
    apiProxyRequest<ApiSshKeyListResponse>(
      `/users/${encodeURIComponent(userId)}/ssh-keys?page[size]=100`
    )
  ).then((response): SshKeyListResponse => ({
    ...response,
    items: response.items.map(normalizeSshKey)
  }));
